import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import useAlias from '@src/hooks/useAlias';
import storeConnector from '@src/store/storeConnector';
import { Actions } from '@src/types/Actions';
import { SiteMeta } from '@src/types/SiteMeta';

interface TemplatesEnableConfirmProps {
  actions: Actions;
  modeName: string;
  siteMeta: SiteMeta;
  setConfirmOpen: (open: boolean) => void;
  activeStatus?: string | number | null | undefined;
}

function TemplatesEnableConfirm({
  actions,
  modeName,
  siteMeta,
  activeStatus,
  setConfirmOpen,
}: TemplatesEnableConfirmProps) {
  const alias = useAlias();
  const isModeDisabled = activeStatus === 1;
  const handleConfirmOnClick = async (): Promise<void> => {
    const commands: string[] = [];
    commands.push(
      `WriteToVariant::Disable_${modeName}_Fractal::${isModeDisabled ? 0 : 1}`,
    );

    if (
      ['Power Factor', 'Voltage Response'].includes(modeName) &&
      isModeDisabled
    ) {
      commands.push(
        `WriteToVariant::Disable_${
          modeName === 'Power Factor' ? 'Voltage Response' : 'Power Factor'
        }_Fractal::1`,
      );
    }

    await actions.sendCommand(commands, siteMeta.siteId);

    await setConfirmOpen(false);
  };

  return (
    <Dialog open>
      <DialogTitle>
        {alias('{action} {modeName}?', {
          action: activeStatus ? alias('Enable') : alias('Disable'),
          modeName,
        })}
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={() => {
            setConfirmOpen(false);
          }}
          color='inherit'
        >
          <FormattedAlias id='Cancel' />
        </Button>
        <Button onClick={handleConfirmOnClick} color='primary'>
          <FormattedAlias id='Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default storeConnector(TemplatesEnableConfirm, {
  config: ['siteMeta'],
});
